import React from 'react';
import PropTypes from 'prop-types';
import { withGoogleMap, GoogleMap, Marker, InfoWindow } from "react-google-maps";
import {BASE_URL} from '../../../src/constants';
import { Button } from 'reactstrap';
import {arrayMove} from 'react-sortable-hoc';
import '../../assets/map_numbers/number_1.png';
import '../../assets/map_numbers/number_2.png';
import '../../assets/map_numbers/number_3.png';
import '../../assets/map_numbers/number_4.png';
import '../../assets/map_numbers/number_5.png';
import '../../assets/map_numbers/number_6.png';
import '../../assets/map_numbers/number_7.png';
import '../../assets/map_numbers/number_8.png';
import '../../assets/map_numbers/number_9.png';
import '../../assets/map_numbers/number_10.png';
import '../../assets/map_numbers/number_11.png';
import '../../assets/map_numbers/number_12.png';
import '../../assets/map_numbers/number_13.png';
import '../../assets/map_numbers/number_14.png';
import '../../assets/map_numbers/number_15.png';
import '../../assets/map_numbers/number_16.png';
import '../../assets/map_numbers/number_17.png';
import '../../assets/map_numbers/number_18.png';
import '../../assets/map_numbers/number_19.png';
import '../../assets/map_numbers/number_20.png';
import '../../assets/map_numbers/number_21.png';
import '../../assets/map_numbers/number_22.png';
import '../../assets/map_numbers/number_23.png';
import '../../assets/map_numbers/number_24.png';
import '../../assets/map_numbers/number_25.png';
import '../../assets/map_numbers/number_26.png';
import '../../assets/map_numbers/number_27.png';
import '../../assets/map_numbers/number_28.png';
import '../../assets/map_numbers/number_29.png';
import '../../assets/map_numbers/number_30.png';
import '../../assets/map_numbers/number_31.png';
import '../../assets/map_numbers/number_32.png';
import '../../assets/map_numbers/number_33.png';
import '../../assets/map_numbers/number_34.png';
import '../../assets/map_numbers/number_35.png';
import '../../assets/map_numbers/number_36.png';
import '../../assets/map_numbers/number_37.png';
import '../../assets/map_numbers/number_38.png';
import '../../assets/map_numbers/number_39.png';
import '../../assets/map_numbers/number_40.png';
import '../../assets/map_numbers/number_41.png';
import '../../assets/map_numbers/number_42.png';
import '../../assets/map_numbers/number_43.png';
import '../../assets/map_numbers/number_44.png';
import '../../assets/map_numbers/number_45.png';
import '../../assets/map_numbers/number_46.png';
import '../../assets/map_numbers/number_47.png';
import '../../assets/map_numbers/number_48.png';
import '../../assets/map_numbers/number_49.png';
import '../../assets/map_numbers/number_50.png';


const GoogleSortableMap = withGoogleMap(props => {
  return (
    <GoogleMap
      ref={props.onMapLoad}
      defaultZoom={15}
      center={props.center}
      zoom={15}
      options={{fullscreenControl:true}}
    >
      {props.markers.map((marker, index) => (
        <Marker key={marker.key}
                {...marker}
                onClick={() => props.onMarkerClick(marker)} ondblclick={() => console.log('hi')}>
          {marker.showInfo && (
            <InfoWindow onCloseClick={() => props.onMarkerClose(marker)}>
              <div className="jumbotron">{marker.infoContent}</div>
            </InfoWindow>
          )}
        </Marker>
      ))}
    </GoogleMap>
  );
});


class SortableMap extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleMarkerClick = this.handleMarkerClick.bind(this);
    this.handleMapLoad = this.handleMapLoad.bind(this);
    this.stateFromProps = this.stateFromProps.bind(this);
    this.finishOrdering = this.finishOrdering.bind(this);
    this.getMarkerPosition = this.getMarkerPosition.bind(this);
    this.cancelReorder = this.cancelReorder.bind(this);
    this.moveIndex = this.moveIndex.bind(this);
    this.resetSelected = this.resetSelected.bind(this);
    this.showHideInfoWindows = this.showHideInfoWindows.bind(this);
    this.handleMarkerClose = this.handleMarkerClose.bind(this);

    this.state = this.stateFromProps(props);
  }

  stateFromProps(nextProps) {
    if (!nextProps.run || !nextProps.isVisible) {
      return {
        markers: [],
        origin: {center: {latLng: {lat: 0, lng: 0}}},
        selectedMarkers: this.state ? this.state.selectedMarkers : [],
        run: {},
        bounds: new google.maps.LatLngBounds(),
        isVisible: nextProps.isVisible,
      };
    }

    let locationSet = [];
    let locations = nextProps.run.pickups.map(x => {
      let latLng = {lat: x.locationLatitude, lng: x.locationLongitude};
      if (locationSet.filter(x => x.lat === latLng.lat && x.lng === latLng.lng).length > 0) {
        latLng = {lat: latLng.lat, lng: latLng.lng + 0.0001};
      } else {
        locationSet.push(latLng);
      }
      return {pickup: x, latLng: latLng, key: x.id};
    });

    let selectedMarkers = this.state ? this.state.selectedMarkers : [];
    let bounds = new google.maps.LatLngBounds();

    let markers = locations.map(x => {
      let index = this.getMarkerPosition(x.pickup, selectedMarkers, nextProps.run);
      let existingMarker = this.state ? this.state.markers.findIndex(y => y.key == x.key) : -1;
      bounds.extend(x.latLng);
      return {
        location: x,
        position: x.latLng,
        key: x.key,
        showInfo: existingMarker >= 0 ? this.state.markers[existingMarker].showInfo : true,
        infoContent: (<div style={{maxWidth: '250px'}}>
          <div><b>{x.pickup.clientCompanyName}</b></div>
        </div>),
        icon: index >= 0 ? `${BASE_URL}/assets/map_numbers/number_${index + 1}.png` : `//maps.google.com/mapfiles/ms/icons/green.png`,
      };
    });

    let origin = locations[0];
    return {markers, origin, selectedMarkers, run: nextProps.run, bounds, isVisible: nextProps.isVisible};
  }

  getMarkerPosition(pickup, selectedMarkers, run){
    let index = selectedMarkers.findIndex(y => y.key == pickup.id);
    index = index >= 0 ? index + 1 : index;
    index = pickup.pickupOrder == 0 ? 0 : index;
    index = pickup.pickupOrder == run.pickups.length - 1 ? run.pickups.length - 1 : index;
    return index;
  }

  componentWillReceiveProps(nextProps) {
    let state = this.stateFromProps(nextProps);
    if(JSON.stringify(state.markers) !== JSON.stringify(this.state.markers)) {
      this.setState(state);
      if (this.state.map) {
        setTimeout(() => this.state.map.fitBounds(state.bounds), 200);
      }
    }
  }
  
  

  componentDidUpdate(){
    if(this.state.map && this.state.map.context){
      //let state = this.stateFromProps(this.state);
      google.maps.event.trigger(this.state.map.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, 'resize');
      //this.state.map.fitBounds(state.bounds);
    }
  }


  handleMapLoad(map){
    if(map){
      this.setState({map});
      let state = this.stateFromProps(this.state);
      map.fitBounds(state.bounds);
    }
  }

  handleMarkerClick(marker) {
    let {selectedMarkers} = this.state;
    let markerIndex = selectedMarkers.findIndex(x => x.key == marker.key);

    if(markerIndex >= 0){
      selectedMarkers.splice(markerIndex, 1);
    } else {
      selectedMarkers.push(marker);
    }
    let {markers} = this.stateFromProps({...this.state, selectedMarkers});
    this.setState({selectedMarkers, markers});
  }

  finishOrdering(){
    let {run, selectedMarkers} = this.state;
    let pickups = [];
    for(let i = 0; i < run.pickups.length; i++){
      let pickup = {...run.pickups[i]};
      let newIndex = this.getMarkerPosition(run.pickups[i], selectedMarkers, run);
      pickup.pickupOrder = newIndex == -1 ? 1000 : newIndex;
      pickup.pickupOrder = newIndex == run.pickups.length-1 ? 1001 : pickup.pickupOrder;
      pickups.push(pickup);
    }

    pickups = pickups.sort((a, b) => {
      if (a.pickupOrder < b.pickupOrder) {
        return -1;
      }
      if (a.pickupOrder > b.pickupOrder) {
        return 1;
      }
      return 0;
    });

    for(let j = 0; j < pickups.length; j++){
      if(pickups[j].pickupOrder >= 1000 ){
        pickups[j].pickupOrder = j;
      }
    }
    let updatedRun = {...run, pickups};
    this.props.onFinishedReorder(updatedRun, selectedMarkers.length > 0);
  }

  cancelReorder(){
    this.props.onFinishedReorder(this.state.run, false);
  }

  resetSelected(){
    let state = this.stateFromProps(this.state);
    state.selectedMarkers = [];
    this.setState(state);
  }

  moveIndex(oldIndex, newIndex){
    oldIndex = oldIndex - 1;
    newIndex = newIndex - 1;
    let {selectedMarkers} = this.state;
    if(oldIndex < selectedMarkers.length && newIndex< selectedMarkers.length){
      this.setState({ selectedMarkers: arrayMove(selectedMarkers, oldIndex, newIndex)});
    } else if (oldIndex < selectedMarkers.length){
      this.setState({selectedMarkers: selectedMarkers.splice(oldIndex, 1)});
    }
  }

  showHideInfoWindows(show){
    let markers = this.state.markers.map(x => {
      let returnVal = x;
      returnVal.showInfo = show;
      return returnVal;
    });

    this.setState(markers);
  }

  handleMarkerClose(targetMarker) {
    this.setState({
      markers: this.state.markers.map(marker => {
        if (marker === targetMarker) {
          return {
            ...marker,
            showInfo: false,
          };
        }
        return marker;
      })
    });
  }

  render() {
    return (
      <div>
        <div style={{marginBottom: '10px' }}>
          <Button color="primary" onClick={this.cancelReorder}><i className="fa fa-mail-reply" /></Button>&nbsp;
          <Button color="primary" onClick={this.finishOrdering}><i className="fa fa-check" /></Button>&nbsp;
          <Button color="secondary" onClick={() => this.showHideInfoWindows(true)}>Show Info</Button>&nbsp;
          <Button color="secondary" onClick={() => this.showHideInfoWindows(false)}>Hide Info</Button>
        </div>
        <GoogleSortableMap
      center={this.state.origin.latLng}
      markers={this.state.markers}
      onMapLoad={this.handleMapLoad}
      onMarkerClick={this.handleMarkerClick}
      onMarkerClose={this.handleMarkerClose}
      containerElement={
        <div style={{height: `800px`, maxWidth:'95%'}}/>
      }
      mapElement={
        <div style={{height: `800px`, maxWidth:'95%'}}/>
      }
      />
    </div>);
  }
}

SortableMap.propTypes = {
  run: PropTypes.object.isRequired,
  onFinishedReorder: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
};

export default SortableMap;